import { Box, Card, CardContent, Typography } from '@atgfr8/atg-ui-tailwind';
import { customerDetailsStore } from '@store/customers/customerDetails';
import { formatAmount } from '@utils/utils';
import { createEffect, createSignal } from 'solid-js';

const GraphContainer = () => {
  const [financials, setFinancials] = createSignal<
    (string | number | null | undefined)[]
  >([]);

  createEffect(() => {
    if (customerDetailsStore.customer.financials) {
      setFinancials([
        formatAmount(
          customerDetailsStore.customer.financials.availableCredit as number,
        ),
        formatAmount(
          customerDetailsStore.customer.outstandingBalance as number,
        ),
        Boolean(customerDetailsStore.customer.financials.balancePastDue)
          ? formatAmount(
              customerDetailsStore.customer.financials.balancePastDue as number,
            )
          : '$ 0.00',
      ]);
    }
  });

  const headers = [
    {
      title: 'Available Credit',
      class: 'bg-[#d6e9c6]!',
      color: '#248670',
    },
    {
      title: 'Outstanding Balance',
      class: 'bg-[#ebccd1]!',
      color: '#B00020',
    },
    { title: 'Balance Past Due', class: 'bg-[#ebccd1]!', color: '#B00020' },
  ];

  return (
    <Box
      style={{
        display: 'flex',
        gap: '16px',
        width: '100%',
        'flex-wrap': 'wrap',
      }}
    >
      {headers.map((header, index) => (
        <Card class={`flex-[1_1_0] h-fit mb-2 ${header.class}`}>
          <CardContent class=" text-center p-3!">
            <Typography
              variant="h6"
              component="span"
              class="text-[18px]! text-[#123B50]!"
            >
              {header.title}
            </Typography>
            <Typography
              variant="body2"
              sxProps={{ color: header.color }}
              class="text-lg! font-bold! break-all"
            >
              {financials()[index]}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default GraphContainer;
